<template>
    <!-- Navbar Section -->
    <nav v-if="!isProfilePage" class="navbar navbar-expand-lg navbar-light">
        <div class="container-fluid mobilenav d-flex align-items-baseline">
            <div class="d-flex w-sm-100 col-4">
                <div class="navbar-brand me-0 w-sm-100">
                    <!-- RouterLink for Internal Navigation -->
                    <RouterLink to="/" class="d-flex mob-row flex-column text-center mob-justify-between gap-2" style="width: fit-content;">
                        <div class="text-start logoDiv">
                        <h1 class="fw-bold fs-1 mb-1" style="color: #175576; text-shadow: 1px 0px #175576;">My City Market</h1>
                        </div>
                    </RouterLink>

                    <!-- External Link (Separate from RouterLink) -->
                    <a href="https://www.eea.gr/" target="_blank">
                        <img class="secondLogo" src="../assets/images/home/logo-epimelitirio-blue.png" alt="">
                    </a>
                </div>
            </div>
            <div class="mb-0 d-flex justify-content-center w-sm-100 col-4">
                <RouterLink class="navbar-brand me-0" to="/">
                    <div class="d-flex mob-row flex-column text-center mob-justify-between gap-2"
                        style="width: fit-content;">
                        <div>
                            <img v-if="apiData" :src="`/storage/LOGOS/${apiData.image_file_name}`" alt="Logo">
                        </div>
                    </div>
                </RouterLink>
            </div>
            <div class="d-flex align-items-center gap-2 w-smScrn-100 mob-column mt-xl-0 searchSection col-4 justify-content-end">
                <div class="registerBtn mt-2">
                    <a href="/business-partner-request">
                        <div class="d-flex flex-column">
                            <div class="fs-3">Καταχώρησε</div>
                            <div class="fs-5">την επιχείρησή σου</div>
                        </div>
                        <span
                            style="width: 25px;height: 25px;background: #54B7F3;color: #fff;border-radius: 100%;display: flex;justify-content: center;align-items: center;font-weight: bold;margin-left: 10px;"><i class="fs-5 fw-bold icofont-curved-right"></i></span>
                    </a>
                </div>
                <!-- <form class="ms-auto w-100 w-smScrn-100 mt-3 mt-xl-0 position-absolute searchDiv" @submit.prevent>
                    <input ref="searchInput" v-model="searchQuery" @keyup="search" @click="search"
                        class="form-control search-input" type="search" placeholder="Αναζήτηση Επιχείρησης..."
                        aria-label="Search">
                    <img v-if="!searchQuery" class="search-icon" src="../assets/images/search-icon.png"
                        alt="Search Icon">
                    
                    <div ref="searchResults" v-if="searchResults.length > 0"
                        class="search-results position-absolute w-100">
                        <div class="card" v-for="business in searchResults" :key="business.id">
                            
                            <RouterLink :to="getLink(business)" class="card-link">
                                <div class="card-body">
                                    <span class="card-title fs-6">{{ business.brandname }}</span>
                                </div>
                            </RouterLink>
                        </div>
                    </div>
                </form> -->
            </div>

        </div>
    </nav>

    <slot />
</template>

<script>
import { RouterLink } from 'vue-router';
import { getAppInfo } from '@/services/appInfo';
import { searchBusinessPartner } from '@/services/business-partners';

export default {
    name: 'MainFrontLayout',
    data() {
        return {
            apiData: null, // Variable to store the API response
            error: null,   // Variable to handle potential errors
            searchQuery: '', // Bound to the search input
            searchResults: [] // Array to hold search results
        };
    },
    computed: {
        isProfilePage() {
            // Check if the current route path is '/profile/'
            return this.$route.path.indexOf('/profile/') !== -1;
        }
    },
    mounted() {
        // API call is made when the component is mounted
        this.fetchData();
        // Add a click listener to handle click outside
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        // Remove the click listener when the component is destroyed
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        async fetchData() {
            try {
                // Replace with your actual API URL
                const response = await getAppInfo();
                this.apiData = response.data.success ? response.data.data : false;
            } catch (error) {
                this.error = error.message || 'Error fetching data';
                console.error(this.error);
            }
        },
        async search() {
            let self = this;
            setTimeout(async () => {
                // Ensure the search query is at least 2 characters long
                if (self.searchQuery.length < 2) {
                    self.searchResults = [];
                    return;
                }
                try {
                    // Call the search API with the current search query
                    const response = await searchBusinessPartner({ search: self.searchQuery });
                    self.searchResults = response.data.success ? response.data.data : []; // Assuming the response contains an array of businesses
                } catch (error) {
                    console.error('Error searching:', error);
                }
            }, 500);
        },
        resetSearchResults() {
            // Clear search results and search query
            this.searchResults = [];
            this.searchQuery = '';
        },
        getLink(business) {
            if (business.business_category_id && Array.isArray(business.business_category_id)) {
                return '/profile/' + business.business_category_id[0] + '/' + business.id;
            }
            if (business.business_category_id) {
                return '/profile/' + business.business_category_id + '/' + business.id;
            } else {
                return '#';
            }
        },
        handleClickOutside(event) {
            const searchInput = this.$refs.searchInput;
            const searchResults = this.$refs.searchResults;

            if (
                searchInput && !searchInput.contains(event.target) &&
                searchResults && !searchResults.contains(event.target)
            ) {
                this.resetSearchResults();
            }
        }
    }
};
</script>

<style scoped>
.navbar {
    padding: 0px 35px 0px 35px;
}

.navbar-brand img {
    height: 120px;
}

.position-relative {
    position: relative;
}

.search-results {
    background: white;
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    z-index: 10;
    max-height: 300px;
    overflow-y: auto;
    margin-top: 41px;
}

.card {
    z-index: 99999;
}

.card-link {
    display: block;
    text-decoration: none;
    color: inherit;
    /* Prevent RouterLink from changing the text color */
    z-index: 99999;
}

.card-link:hover {
    text-decoration: none;
}

.card-body {
    padding: 10px;
}

.search-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    width: 30px;
}

.searchDiv {
    max-width: 350px;
    top: 130%;
    right: 60px;
    display: flex;
    justify-content: end;
}

.search-input {
    border: 0px;
    border-bottom: 2px solid var(--color-300);
    border-radius: 99px;
    width: 270px;
}

.registerBtn a {
    /* background: #175576; */
    color: #175576;
    font-weight: bold;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
}

.secondLogo {
    /* position: absolute;
        left: 50px; */
    height: 90px !important;
    text-align: center;
    margin: 0 auto;
    justify-content: center;
    display: flex;
    align-items: center;
}

@media only screen and (max-width: 890px) {
    .navbar-brand img {
        height: 85px;
    }
    .secondLogo{
        height: 75px;
    }
}

@media only screen and (max-width: 768px) {
    .w-smScrn-100 {
        width: 100% !important;
    }

    .navbar {
        padding: 10px 15px;
    }

    .mob-justify-between {
        justify-content: space-between;
    }

    .mob-column {
        flex-direction: column;
    }

    .mob-row {
        flex-direction: row !important;
        width: 100% !important;
    }

    .secondLogo {
        position: unset;
        height: 70px !important;
    }
    .navbar-brand{
        display: flex;
        gap: 10px;
    }
    .navbar-brand img {
        height: 90px;
    }

    .registerBtn a {
        /* width: 100%;
            position: fixed;
            bottom: 30px;
            border-radius: 0px;
            left:0px;
            justify-content: center;
            z-index: 4; */
        display: none;
    }

    .searchSection {
        max-width: 100%;
        min-width: 100%;
        position: fixed !important;
        bottom: 26px;
        z-index: 4;
        top: unset;
        right: unset;
        left: 0;
    }

    .searchDiv {
        max-width: 100%;
        min-width: 100%;
        position: fixed !important;
        bottom: 26px;
        z-index: 4;
        top: unset;
        right: unset;
        left: 0;
    }

    .search-input {
        width: 100%;
        border-radius: 0px;
        text-align: center;
        background: #f9f9f9;
        box-shadow: inset 0px 5px 10px 0px #dedede;
    }

    .search-icon {
        right: 50px;
    }

    .logoDiv {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }

    .w-sm-100 {
        width: 100%;
    }
}
</style>
